import { useState } from "react"
import { WizardOptions } from "./WizardOptions"
import { Scenario, Licenses } from "../logic/scenarios/data"
import { NotSupportedLinks, isSupported } from "../logic/scenarios/validation"

type WizardProps = {
    scenario: Scenario    
    isOpen: boolean
    close: () => void
    setScenario: (scenario: Scenario) => void
}

const Wizard = ({ scenario, isOpen, close, setScenario } : WizardProps) => {    
    const [currentStep, setStep] = useState(0)
    const supported = isSupported(scenario)

    const choices = WizardOptions({ scenario, setScenario, step: currentStep, setStep })

    if(currentStep == -1) {
        setStep(choices.length)
    }

    return isOpen ? <div id="wizard-backdrop"><div id="wizard">
        <div className="wizard-header">
            How would you like to use Gurobi?
            <button onClick={() => close()}>Apply</button>            
        </div>
        <p>Please descibe how you plan to use Gurobi, so we can provide personalized
            instructions on the next pages. When you are done,
            click <a href="#" className="close" onClick={close}>Apply</a> to
            close this screen and view the instructions. 
            You can always return using the "Wizard" button on the top of the screen.
        </p>
        {supported && <section className="warning">{supported} <NotSupportedLinks/></section>}
        <section className="choice closed">
            <h3>License type</h3>
            <span>{Licenses[scenario.license].name}</span>            
        </section>
        {choices} 
        <footer>
            <a href='/attribution.html' target='_blank'>View image attributions</a>
        </footer>
    </div></div> : <></>
}
    
export default Wizard

